<template>
  <div>
    <div 
      class="card shadow m-3 position-fixed right-0 top-0 z-index-1 width-400 pb-3"
      data-card-name="requestSendToFulfillment"
    >
      <div class="card-body d-flex align-items-center pb-2">
        <div 
          :class="{ 'rotate': !complete }"
          class="mr-3 rounded-round d-flex align-items-center justify-content-center p-2 border-2 border-primary text-primary width-and-height"
        >
          <i class="fa-solid fa-hourglass-half fa-2x" />
        </div>
        <div class="w-100">
          <div class="progress rounded-round mb-2 height-12">
            <div 
              class="progress-bar bg-primary rounded-round" 
              :style="`width:${progressBarWidth}%;`"
            >
              <!-- <span class="label-percent"></span> -->
            </div>
          </div>
          <div>
            <template v-if="fulfillmentName">
              {{ $t(`Sending shipment to`) }} {{ `${fulfillmentName}...` }}
            </template>
          </div>
        </div>
        <button 
          @click="closeModalMethod" 
          type="button"
          class="close align-self-start ml-2 mr-n1 mt-n2"
        >
          <span>×</span>
        </button>
      </div>
      <div class="ml-3">
        <a 
          href="#collapse-requestSendToFulfillment" 
          class="collapsed font-size-sm text-default" 
          data-toggle="collapse"
          ref="toggleCollapse"
          @click="() => wssMessages.length ? rotate = !rotate : {}"
        >
          <span class="text-primary">
            <ins>{{ $t('Response Message') }}</ins>
            <div class="header-elements d-inline-block">
              <div class="list-icons">
                <a
                  :class="['list-icons-item', {'rotate-180': rotate}]"
                  data-action="collapse"
                />
              </div>
            </div>
          </span> 
        </a>
      </div>
      <div 
        class="ml-4"
      >
        <div 
          class="collapse" 
          id="collapse-requestSendToFulfillment"
        >
          <div 
            v-if="wssMessages.length > 0" 
            class="card-body card-body-log-error pl-0 pt-0 pb-0"
          >
            <transition-group 
              name="list" 
              tag="ul" 
              class="list mb-0 list-unstyled"
            >
              <li 
                v-for="list in wssMessages" 
                :key="'list' + list.timestamp" 
                class="font-size-sm my-2 border-bottom ml-1 py-1 list-item"
              >
                <span :class="[list.status ? 'text-success':'text-danger']">{{ $t(list.title) }}</span> <br>
                <span> {{ $t('Request ID') }}: {{ $t(list.requestId) }}</span>  <br>
                <span 
                  v-if="!list.status" 
                  class="text-two-lines"
                > 
                  {{ $t('Message') }}: {{ $t(list.message) }}
                </span>
              </li>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from '@/services/endpoint/tenant.service'
import Cookies from "js-cookie";
import eventBus from '@/plugins/eventBus';

export default {
  data() {
    return {
      totalTracking: 0,
      websocket: null,
      tenant: JSON.parse(Cookies.get('tenant')),
      user: JSON.parse(Cookies.get('user')),
      wssMessages: [],
      rotate : false, 
      fulfillmentName : null,
      completeWebsocket: true
    }
  },
  computed: {
    progressBarWidth() {
      return this.wssMessages.length * 100 / this.totalTracking;
    },
    complete() {
      return this.wssMessages.length == this.totalTracking;
    }
  },
  mounted() {
    this.openModalAndRunning();
  },
  async created() {
    // open eventBus for websocket
    eventBus.on('requestTracking', payload => {
      setTimeout(() => 
        this.wssMessages = this.updateOrCreateItemImmutable([...this.wssMessages], payload)
      , 500)

      eventBus.off('requestTracking', payload)
    })
  },
  methods: {
    updateOrCreateItemImmutable(array, newItem) {
      const index = array.findIndex(item => item.slug === newItem.slug);
      if (index !== -1) {
        return array.map(item => {
          if (item.slug === newItem.slug && item.shipmentId !== newItem.shipmentId) {
            return { ...item, ...newItem };
          } else {
            return item
          }
        });
      } 

      return [newItem, ...array];
    },
    async openModalAndRunning() {
      this.fulfillmentName = this.$store.state.shipment.isFulfillment.name
      let retryFulfillmentListData = this.$store.state.shipment.retryFulfillmentList
      this.totalTracking = retryFulfillmentListData.length
      if (retryFulfillmentListData.length > 0) {
        let param = retryFulfillmentListData.map((shipment) => {
          let totalWeight = 0;
          let totalQty = 0;
          let sku = [];
          let remark = [];

          let shipmentPackage = shipment.shipment_package
          shipmentPackage.forEach(items => {
            let packageItems = items.package_items
            packageItems.forEach(rows => {
              totalWeight += parseFloat(rows.product_weight * rows.ordered_quantity);
              totalQty += parseFloat(rows.ordered_quantity);
              sku.push(rows.sku);
              let productSku = rows.sku;
              if (!productSku) {
                productSku = rows.product_name
              }

              productSku = productSku.replace(/[`~^()|\=?;:'",<>\{\}\[\]\\\/]/gi, '');
              remark.push(`${productSku}(${Number(rows.ordered_quantity)})`);
            });
          });

          const firstSalesOrder = shipment.shipment_package[0].sales_order[0]

          const obj = {
            shipment_id: shipment.id,
            ffm_external_id: `${this.tenant.id}-${shipment.id}`,
            carrier_code: shipment.carrier_channel_code,
            total_qty: totalQty,
            remark: remark,
            fulfillment_code: shipment.carrier_channel_data.fulfillment_shipping_code[this.$store.state.shipment.isFulfillment.code],
            integration_id: shipment.carrier_channel_id,
            user_id: this.user.id,
            tracking_number: shipment.tracking_number,
            cod_amount: firstSalesOrder.payment_method == 'COD' ? firstSalesOrder.total: 0,
            recipient: {
              fullname: shipment.destination_fullname,
              address: shipment.destination_address1,
              county: shipment.destination_county,
              city: shipment.destination_city,
              state: shipment.destination_state,
              postcode: shipment.destination_postcode,
              mobile: shipment.destination_telephone1,
              mobile2: shipment.destination_telephone2,
              email: shipment.destination_email
            }
          }
          
          if(firstSalesOrder.sales_channel_group_id == 3) {
            obj['type'] = 'MKP'
            obj['sales_channel'] = firstSalesOrder.sales_channel_code
            obj['shipment_external_id'] = shipment.external_id
            obj['external_order_number'] = firstSalesOrder.external_order_number
            obj['shop_id'] = firstSalesOrder.sales_channel_external_id
          }

          return  obj
        })

        const chunkSize = 50;
        for (let i = 0; i < param.length; i += chunkSize) {
          let chunk = param.slice(i, i + chunkSize);

          let response = {
            status : 200,
            message : ""
          }

          try {
            let payloads = {
              body: chunk
            }
            if (this.$store.state.shipment.isFulfillment && this.$store.state.user.feature.includes('feature-fulfillment')) {
              payloads.fulfillment_id = this.$store.state.shipment.isFulfillment.id
            }
            await Api.ShipmentV2.postRetrySendFulfillment(payloads);
          } catch (err) {
            response = {
              status: err.response.status,
              message: err.response.message ? err.response.message : err.response.statusText
            }
          }
          if(response.status == 200) continue;
          if(response.status == 403) {
            if(response.message === "ERROR_FEATURE_NOT_ALLOWED") {
              this.$swal.fire({
                imageUrl: require('@/assets/global_assets/images/grongnoi_mee_x_me_akegasan.png'),
                imageWidth: 240,
                title: this.$t("Access Not Available") + "!",
                html: this.$t("Current plan is not support this feature.")+"<br/>"+this.$t("Please subscribe upper plan to access the feature."),
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: '<i class="fa-solid fa-envelope-open-dollar mr-2"></i>' + this.$t("Upgrade Now") + '!',
                buttonsStyling: false,
                cancelButtonText: '<i class="fa-solid fa-circle-check mr-2"></i>' + this.$t("Got It") + '!',
                reverseButtons: true,
                customClass: {
                  confirmButton: "btn btn-primary",
                  cancelButton: "btn btn-outline-primary",
                },
                showLoaderOnConfirm: true,
                preConfirm: () => this.$router.push({ path: '/app/premium-subscriptions'}),
              })
            } else {
              this.$swal.fire({
                imageUrl: require('@/assets/global_assets/images/grongnoi_mee_gunjae_mee_akegasan.png'),
                imageWidth: 240,
                title: this.$t('Access Denied') + "!",
                html: this.$t("You do not have permission to access this page.")+"<br/>"+this.$t("If you feel this is a mistake, contact your admin."),
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: '<i class="fa-solid fa-envelope-open-dollar mr-2"></i>' + this.$t("Got It") + '!',
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                  container: 'z-index-popup-tag',
                  confirmButton: "btn btn-primary",
                  cancelButton: "btn btn-outline-primary",
                },
                showLoaderOnConfirm: true,
              })
            }
            break;
          }
        }
      } else {
        console.log('Not Have Data')
      }
    },
    swalAlert(event = 'request.tracking', action = null) {
      let title, message, toastr = ''
      let icon = 'success'
      switch (event) {
        case 'request.tracking':
          if (action == 'success') {
            title = this.$t('Generate Tracking Success')
            message = this.$t('New tracking no. has been generated.')
            toastr = this.$t("Generate Tracking Complete.")
          } else if (action == 'error') {
            title = `${this.$t('Error')} !`
            message = this.$t('System error')
            icon = 'warning'
          }
          break;
      }

      if (action) {
        this.$swal.fire({
          title: title,
          icon: icon,
          html: message,
          confirmButtonText: this.$t('OK'),
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-light'
          },
          focusConfirm: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then((result) => {
          if (result.isConfirmed) {
            if (action == 'success') {
              this.$toastr.s(toastr, "<i class='fa-solid fa-circle-check mr-2' />" + this.$t('Success'))
            }
          }
          this.$store.dispatch("shipment/updateShipmentDataTable", true)
        })
      }
    },
    closeModalMethod() {
      this.$store.dispatch("shipment/updateShipmentDataTable", true)
      this.$store.dispatch("shipment/isModalSendToFulfillment", false);
    }
  },
  beforeDestroy() {
    if (this.websocket) {
      this.websocket.close();
    }
  },
  watch : {
    wssMessages(nVal, oVal) {
      if(oVal.length == 0 && nVal.length == 1) {
        this.$refs.toggleCollapse.click();
      }

      if(nVal.length == this.totalTracking && this.completeWebsocket) {
        const failed = nVal.filter(({status}) => !status).map(({shipmentId}) => shipmentId);
        const success =  nVal.filter(({status}) => status).map(({shipmentId}) => shipmentId);

        this.$store.dispatch("shipment/setInProgressShipment", {
          shipmentIds: failed,
          status: "cross",
        });

        this.$store.dispatch("shipment/setInProgressShipment", {
          shipmentIds: success,
          status: "checkmark",
        });

        setTimeout(() => {
          this.swalAlert('request.tracking', failed.length > 0 ? 'error' : 'success')
        }, 666)
        this.completeWebsocket = false
      }
    }
  },
}
</script>
<style scoped>
  .z-index-1 {
    z-index: 1;
  }
  .top-100 {
    top: 100px;
  }
  .width-and-height {
    width: 60px;
    height: 50px;
  }
  .width-400 {
    width: 400px;
  }
  .height-12 {
    height: 12px;
  }
  .card-body-log-error {
    max-height: 600px;
    overflow-x: hidden; 
    overflow-y: auto;
  }

  ul.list-unstyled {
    overflow: hidden;
  }

  ul.list-unstyled li.list-item {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #ddd;
    transition: all 0.5s ease;
  }

  ul.list-unstyled li.list-item:last-child { 
    border-bottom: none !important; 
  }

  .list-enter-active, .list-leave-active {
    transition: all 0.5s ease;
  }

  .list-enter, .list-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .text-two-lines {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    white-space: normal;
  }
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/shipment/ModalSendToFulfillment.vue